import {Party, Person} from "./party";
import {Vehicle} from "./vehicle";
import {strings} from "../strings/strings";
import moment, { Moment } from "moment";

export interface Contract {
	id: string;
	startDate: Date;
	endDate: Date;
	duration: Duration;
	primaryInsured: Party;
}

export interface MtplContract extends Contract {
	primaryInsured: Person;
	deductible: number;
	premium: number;
	vehicle: Vehicle;
	raxelPhone: string;
	coverageTerritory?: string;
	agreementPlace: string;
}

export enum Duration {
	DAYS_15 = "DAYS_15",
	DAYS_21 = "DAYS_21",
	MONTH_1 = "MONTH_1",
	MONTHS_2 = "MONTHS_2",
	MONTHS_3 = "MONTHS_3",
	MONTHS_4 = "MONTHS_4",
	MONTHS_5 = "MONTHS_5",
	MONTHS_6 = "MONTHS_6",
	MONTHS_7 = "MONTHS_7",
	MONTHS_8 = "MONTHS_8",
	MONTHS_9 = "MONTHS_9",
	MONTHS_10 = "MONTHS_10",
	MONTHS_11 = "MONTHS_11",
	YEAR_1 = "YEAR_1"
}



export const DurationMap: Record<string, string> = {
	"DAYS_15": strings.durationMapDAYS_15,
	"DAYS_21": strings.durationMapDAYS_21,
	"MONTH_1": strings.durationMapMONTH_1,
	"MONTHS_2": strings.durationMapMONTHS_2,
	"MONTHS_3": strings.durationMapMONTHS_3,
	"MONTHS_4": strings.durationMapMONTHS_4,
	"MONTHS_5": strings.durationMapMONTHS_5,
	"MONTHS_6": strings.durationMapMONTHS_6,
	"MONTHS_7": strings.durationMapMONTHS_7,
	"MONTHS_8": strings.durationMapMONTHS_8,
	"MONTHS_9": strings.durationMapMONTHS_9,
	"MONTHS_10": strings.durationMapMONTHS_10,
	"MONTHS_11": strings.durationMapMONTHS_11,
	"YEAR_1": strings.durationMapYEAR_1,
};

export const DurationMomentsMap = {
	"15Days": (start: Moment) => start.add(15, 'days'),
	"21Days": (start: Moment) => start.add(21, 'days'),
	"1Month": (start: Moment) => start.add(1, 'months'),
	"2Months": (start: Moment) => start.add(2, 'months'),
	"3Months": (start: Moment) => start.add(3, 'months'),
	"4Months": (start: Moment) => start.add(4, 'months'),
	"5Months": (start: Moment) => start.add(5, 'months'),
	"6Months": (start: Moment) => start.add(6, 'months'),
	"7Months": (start: Moment) => start.add(7, 'months'),
	"8Months": (start: Moment) => start.add(8, 'months'),
	"9Months": (start: Moment) => start.add(9, 'months'),
	"10Months": (start: Moment) => start.add(10, 'months'),
	"11Months": (start: Moment) => start.add(11, 'months'),
	"12Months": (start: Moment) => start.add(1, 'years')
};

export const DurationConvertMap = {
	"DAYS_15": "15Days",
	"DAYS_21": "21Days",
	"MONTH_1": "1Month",
	"MONTHS_2": "2Months",
	"MONTHS_3": "3Months",
	"MONTHS_4": "4Months",
	"MONTHS_5": "5Months",
	"MONTHS_6": "6Months",
	"MONTHS_7": "7Months",
	"MONTHS_8": "8Months",
	"MONTHS_9": "9Months",
	"MONTHS_10": "10Months",
	"MONTHS_11": "11Months",
	"YEAR_1": "12Months",
};
